module.exports = __webpack_public_path__ + "img/sanduicheira.0c145cb1.png";